import { fetchApiGraphQL } from '@/utils/fetcher';

export type PostalCode = {
    code: string;
    city: string;
};

/** Every Danish postcode with its city - about a thousand rows. */
export async function getPostalCodes(): Promise<PostalCode[]> {
    const result = await fetchApiGraphQL<{ data: { postalCodes: { items: PostalCode[] } } }>(
        'query { postalCodes { items { code city } } }', {});
    return result?.data?.postalCodes?.items ?? [];
}
